import { graphqlRequest } from "../graphqlClient";
import type {
	ScenarioDataPointViewConnection,
	ScenarioDataPointViewFilterInput,
} from "../models/scenarioDataPointView";

export interface ScenarioDataPointViewSortInput {
	field: string;
	order: "Ascending" | "Descending";
}

/** Ensures every request is scoped to a single scenario. */
function withScenario(
	scenarioId: number,
	filter?: ScenarioDataPointViewFilterInput,
): ScenarioDataPointViewFilterInput {
	return { ...filter, scenarioId: { eq: scenarioId } };
}

interface ScenarioDataPointViewListResponse {
	scenarios: {
		scenarioDataPointViewList: ScenarioDataPointViewConnection;
	};
}

export async function getScenarioDataPointsGraphql(
	scenarioId: number,
	filter?: ScenarioDataPointViewFilterInput,
	first?: number,
	after?: string,
	sort?: ScenarioDataPointViewSortInput[],
): Promise<ScenarioDataPointViewConnection> {
	const query = `
    query ScenarioDataPointViewList($filter: ScenarioDataPointViewFilterInput, $first: Int, $after: String, $sort: [ScenarioDataPointViewSortSortByInput!]) {
      scenarios {
        scenarioDataPointViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              scenarioId
              date
              openingBalance
              balance
              incoming
              outgoing
              confidenceScore
              contributingLayers
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
	const data = await graphqlRequest<ScenarioDataPointViewListResponse>(query, {
		filter: withScenario(scenarioId, filter),
		first,
		after,
		sort,
	});
	return data.scenarios.scenarioDataPointViewList;
}

interface ScenarioDataPointViewCountResponse {
	scenarios: {
		scenarioDataPointViewCount: number;
	};
}

export async function getScenarioDataPointsCount(
	scenarioId: number,
	filter?: ScenarioDataPointViewFilterInput,
): Promise<number> {
	const query = `
    query ScenarioDataPointViewCount($filter: ScenarioDataPointViewFilterInput) {
      scenarios {
        scenarioDataPointViewCount(filter: $filter)
      }
    }
  `;
	const data = await graphqlRequest<ScenarioDataPointViewCountResponse>(query, {
		filter: withScenario(scenarioId, filter),
	});
	return data.scenarios.scenarioDataPointViewCount;
}
